import { render } from "./ProductBox.vue?vue&type=template&id=31f9143a&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"

import "./ProductBox.vue?vue&type=style&index=0&id=31f9143a&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f9143a"]])

export default __exports__